import { GetScrapFinanceTradesApi } from "@/features/accounts/scrap-finance/services/get-trades-api";
import { GetScrapFinanceTradesRequestModel } from "@/features/accounts/scrap-finance/services/get-trades-model";

/// 銀行明細一覧取得処理
export class GetScrapFinanceTradesService {
  private getScrapFinanceTradesApi = new GetScrapFinanceTradesApi();

  /**
   * 銀行明細一覧取得API実行
   */
  public async getScrapFinanceTrades(param: GetScrapFinanceTradesRequestModel) {
    return await this.getScrapFinanceTradesApi.getScrapFinanceTrades(param);
  }
}
